import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';

/**
 * Blocks pointer and keyboard activation in capture phase when condition is true.
 * Allows hover (mouseover/mouseenter) to pass through for tooltips.
 * Use on wrapper when isViewOnly to prevent dropdown/datepicker from opening.
 */
@Directive({
  selector: '[appPreventClickInViewMode]',
  standalone: false
})
export class PreventClickInViewModeDirective implements OnInit, OnDestroy {
  @Input() appPreventClickInViewMode = false;

  private boundPointerHandler = (event: Event) => this.handlePointer(event);
  private boundKeyHandler = (event: Event) => this.handleKey(event);

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    const native = this.el.nativeElement;
    native.addEventListener('mousedown', this.boundPointerHandler, {
      capture: true
    });
    native.addEventListener('click', this.boundPointerHandler, {
      capture: true
    });
    native.addEventListener('keydown', this.boundKeyHandler, { capture: true });
  }

  ngOnDestroy(): void {
    const native = this.el.nativeElement;
    native.removeEventListener('mousedown', this.boundPointerHandler, {
      capture: true
    });
    native.removeEventListener('click', this.boundPointerHandler, {
      capture: true
    });
    native.removeEventListener('keydown', this.boundKeyHandler, {
      capture: true
    });
  }

  private handlePointer(event: Event): void {
    if (!this.appPreventClickInViewMode) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
  }

  /** Space / Enter / arrows can open mat-select without a click. */
  private handleKey(event: Event): void {
    if (!this.appPreventClickInViewMode || !(event instanceof KeyboardEvent)) {
      return;
    }
    const key = event.key;
    if (
      key !== ' ' &&
      key !== 'Enter' &&
      key !== 'ArrowDown' &&
      key !== 'ArrowUp'
    ) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
  }
}
